/* global axios */

import ApiClient from './ApiClient';

class AgentBotManagement extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }
  
  get({ searchKey } = {}) {
    const params = {};
    if (searchKey) params.search = searchKey;
    
    return axios.get(this.url, { params });
  }
}

export default new AgentBotManagement();
